
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jpeg" 
                alt="ZOLLER" 
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4">
              高精度測定技術のリーディングカンパニー
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">製品情報</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">ツールプリセッター</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">測定機器</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">ソフトウェア</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">お問い合わせ</h3>
            <div className="space-y-2 text-gray-300">
              <p>ZOLLER Japan株式会社 大阪本社</p>
              <p>TEL: 06-6138-1910</p>
              <p>FAX: 06-6318-1911</p>
              <p>E-mail: event@zoller-jp.com</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 ZOLLER Japan株式会社. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
